module.exports = __webpack_public_path__ + "static/media/printerSmall.90199a74.svg";